import {formatCellValue as formatCellHelper} from "@/libs/helper/formatCellValue";
export const NeoDuration: React.FC<any> = ({data, uid}) => {
  //console.log(data, uid);
  const duration = data[uid] || 0;

  return (
    <>
      <div className="flex gap-1">
        {formatCellHelper.formatDuration(duration)}
      </div>
    </>
  );
};
